import "./sentry.js";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./setup/reactQuery";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
    gtmId: import.meta.env.VITE_GTM_ID,
    auth: import.meta.env.VITE_GTM_AUTH,
    preview: import.meta.env.VITE_GTM_PREVIEW,
}

TagManager.initialize(tagManagerArgs)

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
